import styled from 'styled-components';
export const ChipWrapper = styled.button `
  margin: 0px;
  display: flex;
  gap: 4px;
  width: ${({ label }) => (label ? 'max-content' : '32px')};
  height: 32px;
  padding: 6px;
  align-items: center;
  justify-content: center;
  border-radius: ${({ label }) => (label ? '16px' : '100%')};
  background-color: ${({ variant, backgroundColor }) => variant !== 'outlined' && backgroundColor ? backgroundColor : '#FFF'};
  border: ${({ variant, color, backgroundColor }) => `1px solid ${variant === 'outlined' ? color : backgroundColor}`};
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
  pointer-events: ${({ onClick }) => (onClick ? 'auto' : 'none')};
`;
//# sourceMappingURL=styled.js.map